import { TagesgeschaeftMailboxesSection } from "./sections/tagesgeschaeft/TagesgeschaeftMailboxesSection";
import { useSettingsAcl } from "./lib/useSettingsAcl";
import { SettingsAccessDenied } from "./SettingsLayout";

export function TagesgeschaeftSettingsPage() {
  const acl = useSettingsAcl();
  if (acl.loading) return null;
  if (!acl.canAuftraege) return <SettingsAccessDenied />;
  return (
    <div className="space-y-6">
      <TagesgeschaeftMailboxesSection />
    </div>
  );
}
